import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledLink = styled.a`
  color: #fff;
  opacity: 0.75;
  font-size: ${theme.token.var('fontSizes.sm')};
  cursor: pointer;
  text-align: center;
  margin-bottom: 28px;

  @media (min-width: ${theme.token('breakpoints.md')}) {
    margin-right: 70px;
    margin-bottom: 0;
    text-align: left;
  }
`
